import { Grid } from '@/common/grid/Grid';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const AbvMediShaGrid = ({ endPeriod, prodIds, stateIds }) => {

    const rsrc = useRsrc();

    const [data, setData] = useState([]);
    const [fieldDefs, setFieldDefs] = useState();

    useEffect(() => {      
        const reqParam = {
            endPeriod,
            prodIds,
            stateIds
        };
        rsrc.data('gtn', 'MEDI_SHA_GRID_DATA_PLUGIN', reqParam).then(data => {
          const rows = Array.isArray(data) ? data : [];
          const firstRow = rows[0] || null;
          const keys = firstRow ? Object.keys(firstRow) : [];

          const isQtrAvg = (key) => /^\d{4}Q[1-4]$/.test(key); 
          const isCompareColumn = (key) => /\bvs\b|_vs_|\s+vs\s+/i.test(key);
          const isYtd = (key) => /^YTD/i.test(key) || /YTD$/.test(key);
          const isUtilization = (key) => /medicaid/i.test(key) && /utilization/i.test(key);

          const quarterSortKey = (key) => {
            const match = key.match(/(\d{4})Q([1-4])/);
            if (!match) return Number.MAX_SAFE_INTEGER;
            return Number(match[1]) * 10 + Number(match[2]);
          };

          const codeKeys = keys.filter((key) => key === 'code');
          const quarterKeys = keys.filter((key) => isQtrAvg(key));
          const compareKeys = keys.filter((key) => !isQtrAvg(key) && isCompareColumn(key));
          const ytdKeys = keys.filter((key) => !isQtrAvg(key) && !isCompareColumn(key) && isYtd(key));
          const utilizationKeys = keys.filter((key) => isUtilization(key));

          quarterKeys.sort((a, b) => quarterSortKey(a) - quarterSortKey(b));
          compareKeys.sort((a, b) => quarterSortKey(a) - quarterSortKey(b));

          const ytdSortKey = ytdKeys[0];
          const sortedRows = ytdSortKey
            ? [...rows].sort((a, b) => {
                const aVal = Number(a?.[ytdSortKey] ?? 0);
                const bVal = Number(b?.[ytdSortKey] ?? 0);
                return bVal - aVal;
              })
            : rows;
          setData(sortedRows);

          const nextFieldDefs = [
            ...codeKeys.map((key) => ({ field: key })),
            ...quarterKeys.map((key) => ({ field: key, type: 'NUMBER' })),
            ...compareKeys.map((key) => ({ field: key, type: 'PERCENT' })),
            ...ytdKeys.map((key) => ({ field: key, type: 'NUMBER' })),
            ...utilizationKeys.map((key) => ({ field: key, type: 'PERCENT' })),
          ];

          setFieldDefs(nextFieldDefs);
        });
    }, [endPeriod, prodIds, stateIds]);

     if (!fieldDefs) return;
      return (
        <>
          <Grid
            key={JSON.stringify(fieldDefs)}
            gridOptions={{
              fieldDefs,
              rowData: data,
              rowModelType: 'clientSide',
              statusBar: null,
              defaultColDef: {
                flex: 1,
                minWidth: 120,
              },
            }}
          />
        </>
    
      );
}